import Comments from './Comments'

export default Comments
// eslint-disable-next-line import/export
export * from './Comments'
